<router-outlet></router-outlet>
<div>
  <ngx-spinner bdColor = "rgba(0, 0, 0, 0.6)"
               size = "medium"
               color = "#5d9cec"
               type = "ball-clip-rotate"
               [fullScreen] = "true"
  ></ngx-spinner>
</div>
